<template>
  <div>
    <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(addSlots)">
        <b-row>
          <b-col md="12" class="mb-3">
            <main-select labelTitle='Flow' :validate="'required'"
                         :name="`Flow`" placeholder="Pick flow" :options="allFlows"
                         label="name" :disabled="typeOfModal === 'edit'"
                         :reduce="data => data.id"
                         v-model="schedule.service_id"></main-select>
          </b-col>
          <b-col md="12" class="position-relative mb-4 border-bottom"
                 v-for="(slot, slotKey) in schedule.slots" :key="slotKey">
            <b-row class="d-flex align-items-center mb-4">
              <b-col md="4" >
                <main-select labelTitle='Day of the week' :validate="'required'"
                             :name="`Day ${slotKey + 1}`"  placeholder="Choose" :options="allDays"
                             label="key"
                             :multiple="typeOfModal==='add'"
                             :reduce="data => data.value"
                             v-model="slot.day"></main-select>
              </b-col>
              <b-col md="4">
                <input-form
                    placeholder="00:00" :validate="'required'"
                    :name="`From ${slotKey + 1}`" :label="'From'"
                    v-model="slot.from" type="time"
                />
              </b-col>
              <b-col md="4">
                <input-form
                    placeholder="00:00" alidate="'required'"
                    :name="`To ${slotKey + 1}`" :label="'To'"
                    v-model="slot.to" type="time"
                />
              </b-col>
              <b-col md="12">
                <main-select labelTitle='instructors' :validate="'required'"
                             :name="`instructors ${slotKey + 1}`"  placeholder="Pick instructors"
                             :options="!schedule.service_id ? '':
                             allFlows.find((flow) => flow.id === schedule.service_id).instructors"
                             label="first_name"
                             :multiple="true"
                             :reduce="data => data.id"
                             v-model="slot.instructors"></main-select>
              </b-col>
              <b-col>
                <b-form-checkbox type="checkbox"
                                 value="1"
                                 unchecked-value="0"
                                 v-model="slot.ladies_only" label="Ladies only" :name="`Ladies only ${slotKey + 1}`"
                                 class="custom-checkbox-color-check mb-2 mr-sm-2 mb-sm-0" color="warning">
                  Ladies Only Class
                </b-form-checkbox>
              </b-col>
            </b-row>
            <span v-if="(slotKey != 0)" class="text-danger deleteLabelButton cursor-pointer"
                  @click="deleteSlot(slotKey)">Delete</span>
          </b-col>
          <b-col md="12" class="mb-3">
            <span class="text-warning cursor-pointer deleteLabelButton px-3" v-if="(typeOfModal === 'add')"
                  @click="addNewSlot">+Add another slot(s)</span>
          </b-col>
        </b-row>
        <b-row v-if="typeOfModal != 'view'">
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center" v-if="typeOfModal == 'add'">
              <b-button class="button-orange-modal" type="submit" v-if="!requestLoading">
                <i class="las la-plus"></i>
              </b-button>
              <b-button class="button-orange-modal" v-else>
                <spinner-loading></spinner-loading>
              </b-button>
            </div>
            <div class="d-flex justify-content-center" v-if="typeOfModal == 'edit'">
              <b-button class="button-blue-modal" type="submit" v-if="!requestLoading">
                <i class="las la-pen"></i>
              </b-button>
              <b-button class="button-blue-modal" v-else>
                <spinner-loading></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validationObserver>
  </div>
</template>

<script>

export default {
  props: {
    requestLoading: {
      type: Boolean,
      default: false
    },
    typeOfModal: {
      type: String,
      default: 'add'
    },
    scheduleDetails: {
      type: Object
    },
    allFlows: {
      type: Array
    }
  },
  data () {
    return {
      schedule: {
        slots: [{
          id: '',
          day: [],
          from: '',
          to: '',
          instructors: '',
          ladies_only: +false,
          status: ''
        }],
        status: 'active',
        service_id: '',
        flow_name: ''
      },
      allDays: [
        {
          key: 'Saturday',
          value: 'saturday'
        }, {
          key: 'Sunday',
          value: 'sunday'
        }, {
          key: 'Monday',
          value: 'monday'
        }, {
          key: 'Tuesday',
          value: 'tuesday'
        }, {
          key: 'Wednesday',
          value: 'wednesday'
        }, {
          key: 'Thursday',
          value: 'thursday'
        }, {
          key: 'Friday',
          value: 'friday'
        }
      ]
    }
  },
  methods: {
    addSlots () {
      if (this.typeOfModal === 'add') {
        this.$emit('addSlots', this.schedule)
      } else {
        this.schedule.slots[0].status = this.scheduleDetails.status
        this.schedule.slots[0].from = this.schedule.slots[0].from.slice(0, 5)
        this.schedule.slots[0].to = this.schedule.slots[0].to.slice(0, 5)
        this.schedule.slots[0].ladies_only = +this.schedule.slots[0].ladies_only

        console.log('this.schedule => ',  this.schedule)
        const obj = {
          service_id: this.schedule.service_id,
          ...this.schedule.slots[0],
          instructors: this.schedule.slots[0].instructors.map((instructor) => {
            return instructor.id || instructor
          }),
          ladies_only: this.schedule.slots[0].ladies_only,
          _method: 'put'
        }
        this.$emit('editSlot', this.schedule.slots[0].id, obj)
      }
    },
    addNewSlot () {
      this.schedule.slots.push({
        days: [],
        from: '',
        to: '',
        instructors: '',
        ladies_only: +false
      })
    },
    deleteSlot (ind) {
      this.schedule.slots.splice(ind, 1)
    }
  },
  created () {
    console.log(this.scheduleDetails.id, this.scheduleDetails.day, this.scheduleDetails.from,
      this.scheduleDetails.to, this.scheduleDetails.instructors, this.scheduleDetails.ladies_only,
      this.scheduleDetails.status)
    if (this.scheduleDetails) {
      this.schedule = {
        slots: [{
          id: this.scheduleDetails.id,
          day: this.scheduleDetails.day,
          from: this.scheduleDetails.from,
          to: this.scheduleDetails.to,
          instructors: this.scheduleDetails.instructors,
          ladies_only: +this.scheduleDetails.ladies_only,
          status: this.scheduleDetails.status
        }],
        status: 'active',
        service_id: this.scheduleDetails.service_id,
        flow_name: this.scheduleDetails.service.name
      }
    }
    console.log(this.schedule)
  }

}
</script>
